// SPAの場合はfallbackさせるため`false`にする
// https://kit.svelte.jp/docs/adapter-static
export const prerender = true;

export const trailingSlash = "always";
